module.exports = __webpack_public_path__ + "ui/img/teambot-connect-logo-vector.e5e28dde.png";